import { createI18n } from 'vue-i18n';

const messages = {
    en: {
        navigation: {
            home: 'Home',
            services: 'Services',
            contact: 'Contact',
            gallery: 'Gallery',
            prices: 'Prices',
            auto: '3D AUTO',
        },
        centering: 'Centering',
        automotiveService: 'Automotive Service',
        contactUs: 'Contact Us',
        instagram: 'Instagram',
        email: 'E-mail',
        whatareweoffering: 'What are we offering?',
        home: {
            eyebrow: 'Precision wheel alignment in Gostivar',
            lead: 'Professional 3D wheel alignment with Techno Vector 7, chassis inspection, and clear service for cars, vans, and off-road vehicles.',
            call: 'Call now',
            services: 'View services',
            statOne: '4-camera 3D system',
            statTwo: 'Cars, vans and 4x4',
            statThree: 'Chassis check first',
            introTitle: 'Built for safer, smoother driving',
            introCopy: 'Correct alignment gives your vehicle better stability, protects the tires, and makes every kilometer feel cleaner. We check the vehicle before adjustment so the result is based on the real condition of the chassis.',
            priceCta: 'See price list',
            galleryCta: 'Open gallery'
        },
        pages: {
            servicesEyebrow: 'Service menu',
            servicesLead: 'Everything is focused on one thing: accurate geometry, stable handling, and tires that last longer.',
            contactEyebrow: 'Visit or call',
            contactLead: 'Book your alignment, ask for availability, or open the map and drive straight to the workshop.',
            galleryEyebrow: 'Real cars, real work',
            galleryLead: 'Overview of the workshop and vehicles aligned at 3D Auto Centering Gostivar.',
            pricesEyebrow: 'Transparent pricing',
            pricesLead: 'Choose the price list for your language and contact us if you need help picking the right category.'
        },
        labels: {
            precision: 'Precision',
            stability: 'Stability',
            safety: 'Safety',
            openMap: 'Open map',
            writeInstagram: 'Instagram',
            leaveGoogleReview: 'Leave Google review',
            tiktok: 'TikTok',
            workshop: 'Workshop',
            quickContact: 'Quick contact'
        },
        contactInfo: {
            contactPerson: 'Contact Person',
            address: 'Address',
            phone: 'Phone',
            machine: 'Techno Vector 7 Machine',
            workingHours: 'Working Hours',
            advancedSystem: 'Advanced 3D Alignment System',
            monSat: 'Mon-Sat: 9:00 AM - 5:00 PM',
            sun: 'Sun: Closed'
        },
        socialMedia: 'Follow us on our social media',
        servicesDetails: {
            machine: 'Techno Vector 7',
            machineDesc: 'We use the advanced Techno Vector 7, featuring a 3D 4-camera system for precise wheel alignment. This cutting-edge technology provides real-time measurements, ensuring accuracy and optimal vehicle performance.',

            alignment: 'Comprehensive Wheel Alignment',
            alignmentDesc: 'Our alignment process ensures the front axle, rear axle, and all wheels are correctly positioned. This improves handling, stability, and tire lifespan. We service cars, vans, and off-road jeeps for smooth and safe driving.',

            chassisCheck: 'Pre-Alignment Chassis Inspection',
            chassisCheckDesc: 'Before performing the alignment, we inspect the chassis, and key components underneath the vehicle. This allows us to detect any potential issues or necessary replacements, ensuring a solid foundation for the alignment process.'
        }
    },
    mkd: {
        navigation: {
            home: 'Почетна',
            services: 'Што нудиме',
            contact: 'Контакт',
            gallery: 'Галерија',
            prices: 'Ценовник',
            auto: '3Д АВТО',
        },
        centering: 'Центрирање',
        automotiveService: 'Автомобилски сервис',
        contactUs: 'Контактирајте не',
        instagram: 'Инстаграм',
        email: 'Е-маил',
        whatareweoffering: 'Што ви нудиме?',
        home: {
            eyebrow: 'Прецизно 3Д центрирање во Гостивар',
            lead: 'Професионално 3Д центрирање со Techno Vector 7, проверка на подвозје и јасна услуга за автомобили, комбиња и оф-роуд возила.',
            call: 'Јави се сега',
            services: 'Види услуги',
            statOne: '3Д систем со 4 камери',
            statTwo: 'Автомобили, комбиња и 4x4',
            statThree: 'Прво проверка на подвозје',
            introTitle: 'Направено за побезбедно и помирно возење',
            introCopy: 'Правилното центрирање носи подобра стабилност, ги чува гумите и го прави секој километар почист. Пред подесување го проверуваме возилото за резултатот да биде според реалната состојба на трапот.',
            priceCta: 'Види ценовник',
            galleryCta: 'Отвори галерија'
        },
        pages: {
            servicesEyebrow: 'Услуги',
            servicesLead: 'Се е насочено кон една работа: точна геометрија, стабилно управување и подолг живот на гумите.',
            contactEyebrow: 'Посетете не или јавете се',
            contactLead: 'Закажете центрирање, прашајте за термин или отворете мапа и дојдете директно до сервисот.',
            galleryEyebrow: 'Вистински возила, вистинска работа',
            galleryLead: 'Преглед во работилницата и возилата центрирани во 3D Auto Centering Gostivar.',
            pricesEyebrow: 'Јасен ценовник',
            pricesLead: 'Одберете ценовник според јазик и контактирајте не ако ви треба помош за правилната категорија.'
        },
        labels: {
            precision: 'Прецизност',
            stability: 'Стабилност',
            safety: 'Безбедност',
            openMap: 'Отвори мапа',
            writeInstagram: 'Инстаграм',
            leaveGoogleReview: 'Остави Google review',
            tiktok: 'TikTok',
            workshop: 'Работилница',
            quickContact: 'Брз контакт'
        },
        contactInfo: {
            contactPerson: 'Лице за Контакт',
            address: 'Адреса',
            phone: 'Телефон',
            machine: 'Техно Вектор 7 Машина',
            workingHours: 'Работно време',
            advancedSystem: 'Напреден 3Д систем за центрирање',
            monSat: 'Понеделник - Сабота: 9:00 - 17:00',
            sun: 'Недела: Затворено'
        },
        socialMedia: 'Следете не на нашите социјални мрежи',
        servicesDetails: {
            machine: 'Techno Vector 7',
            machineDesc: 'Ние користиме напредна Techno Vector 7 машина, која е опремена со 3D систем со 4 камери за прецизно поставување на тркалата. Оваа најнова технологија обезбедува мерења во реално време, што гарантира точност и оптимални перформанси на возилото.',

            alignment: 'Комплетно поставување на тркала',
            alignmentDesc: 'Нашиот процес на поставување на тркала обезбедува правилно позиционирање на предниот и задниот трап, како и на сите тркала. Ова го подобрува управувањето, стабилноста и животниот век на гумите. Нудиме услуги за автомобили, комбиња и оф-роуд џипови за безбедно и сигурно возење.',

            chassisCheck: 'Проверка на подвозјето пред центрирање на возилото',
            chassisCheckDesc: 'Пред да го поставиме возилото на машина за центрирање, извршуваме детална проверка на подвозјето и клучните компоненти под возилото. Ова ни овозможува да откриеме потенцијални проблеми или потребни замени, осигурувајќи стабилна основа за процесот на центрирање.'
        }

    },
    al: {
        navigation: {
            home: 'Ballina',
            services: 'Shërbime',
            contact: 'Kontakt',
            gallery: 'Galeria',
            prices: 'Çmimet',
            auto: '3D Makina'
        },
        centering: 'Përqendrimi',
        automotiveService: 'Shërbimi i automobilave',
        contactUs: 'Na kontaktoni',
        instagram: 'Instagram',
        email: 'E-mail',
        whatareweoffering: 'Çfarë po ofrojmë?',
        home: {
            eyebrow: 'Balancim dhe centrim 3D në Gostivar',
            lead: 'Centrim profesional 3D me Techno Vector 7, kontroll i shasisë dhe shërbim i qartë për vetura, furgonë dhe automjete off-road.',
            call: 'Telefono tani',
            services: 'Shiko shërbimet',
            statOne: 'Sistem 3D me 4 kamera',
            statTwo: 'Vetura, furgonë dhe 4x4',
            statThree: 'Së pari kontroll shasie',
            introTitle: 'Për vozitje më të sigurt dhe më të qetë',
            introCopy: 'Centrimi i saktë jep stabilitet më të mirë, ruan gomat dhe e bën çdo kilometër më të qetë. Para rregullimit kontrollojmë automjetin që rezultati të bazohet në gjendjen reale të pjesëve.',
            priceCta: 'Shiko çmimet',
            galleryCta: 'Hap galerinë'
        },
        pages: {
            servicesEyebrow: 'Shërbimet',
            servicesLead: 'Gjithçka fokusohet në një qëllim: gjeometri të saktë, drejtim stabil dhe jetë më të gjatë të gomave.',
            contactEyebrow: 'Vizitë ose telefonatë',
            contactLead: 'Rezervoni termin, pyesni për disponueshmëri ose hapni hartën dhe ejani direkt në servis.',
            galleryEyebrow: 'Vetura reale, punë reale',
            galleryLead: 'Përmbledhje nga punëtoria dhe automjetet e centruara në 3D Auto Centering Gostivar.',
            pricesEyebrow: 'Çmime të qarta',
            pricesLead: 'Zgjidhni çmimoren sipas gjuhës dhe na kontaktoni nëse ju duhet ndihmë për kategorinë e duhur.'
        },
        labels: {
            precision: 'Precizion',
            stability: 'Stabilitet',
            safety: 'Siguri',
            openMap: 'Hap hartën',
            writeInstagram: 'Instagram',
            leaveGoogleReview: 'Lër Google review',
            tiktok: 'TikTok',
            workshop: 'Punëtoria',
            quickContact: 'Kontakt i shpejtë'
        },
        contactInfo: {
            contactPerson: 'Personi i kontaktit',
            address: 'Adresa',
            phone: 'Telefoni',
            machine: 'Techno Vector 7 Makina',
            workingHours: 'Orari i punës',
            advancedSystem: 'Sistemi i avancuar i përqendrimit',
            monSat: 'Hën-Sht: 9:00 - 17:00',
            sun: 'Die: E mbyllur'
        },
        socialMedia: 'Na ndiqni në rrjetet tona sociale',
        servicesDetails: {
            machine: 'Techno Vector 7',
            machineDesc: 'Ne përdorim Techno Vector 7, një sistem i avancuar me 4 kamera 3D për një vendosje të saktë të rrotave. Kjo teknologji moderne siguron matje në kohë reale, duke garantuar saktësi dhe performancë optimale të automjetit.',

            alignment: 'Vendosje e Plotë e Rrotave',
            alignmentDesc: 'Procesi ynë i vendosjes siguron që aksesi i përparmë, aksesi i pasëm dhe të gjitha rrotat të jenë pozicionuar saktë. Kjo përmirëson manovrimin, stabilitetin dhe jetëgjatësinë e gomave. Ne ofrojmë shërbime për makina, furgona dhe xhipa off-road për një udhëtim të sigurt dhe të qetë.',

            chassisCheck: 'Inspektimi i Shasisë dhe Suspencionit para Vendosjes së Rrotave',
            chassisCheckDesc: 'Përpara se ta vendosim automjetin në makinë për vendosjen e rrotave, ne bëjmë një inspektim të thelluar të shasisë, suspencionit dhe komponentëve të rëndësishëm nën automjet. Kjo na lejon të zbulojmë çdo problem të mundshëm ose nevojë për zëvendësim, duke siguruar një bazë të qëndrueshme për procesin e vendosjes.'
        }

    }
};

const i18n = createI18n({
    locale: 'en', // Default language
    fallbackLocale: 'en',
    messages,
});

export default i18n;
